import { getInterfaceLanguage } from 'core/core.selectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getAntdLocale } from './antd-provider.get-antd-locale';

export const useLocale = () => {
  const currentLanguage = useSelector(getInterfaceLanguage);
  return useMemo(() => getAntdLocale(currentLanguage), [currentLanguage]);
};
